import React, { useEffect, useState } from "react";
import { DeviceFooter, DeviceHeader, DeviceIcon, DeviceMetricName, DeviceMetricStatus, DeviceMetricStatusWrapper, DeviceMetricUnit, DeviceMetricValue, DeviceMetricValueWrapper, DeviceMetricWrapper, DeviceMetricsWrapper, DeviceName, DeviceStatus, DeviceWrapper, ElectricWheelConciseInnerWrapper, ElectricWheelConciseOverviewWrapper, LastUpdatedTime, OverviewBigScreenContent, ScreenTitleBar, ViewDeviceDetails } from "./ElectricWheelConciseOverview.styled";
import Navigator from "./component/navigator/Navigator";
import DeviceApi from "../../../../api/DeviceApi";
import { Flex } from "antd";
import moment from "moment";
import DeviceMetricApi from "../../../../api/DeviceMetricApi";
import { useNavigate } from "react-router-dom";


interface ElectricWheelConciseOverviewProps {
}

export const ElectricWheelConciseOverview: React.FC<ElectricWheelConciseOverviewProps> = (props) => {
    // api
    let deviceApi = new DeviceApi();
    let deviceMetricApi = new DeviceMetricApi();
    let navigate = useNavigate();

    // state
    let [deviceViews, setDeviceViews] = useState<any[]>([]);
    let [deviceId2LatestDeviceMetrics, setDeviceId2LatestDeviceMetrics] = useState<any>(null);
    
    // functions
    let fetchDeviceViews = async ()=> {
        deviceViews = (await deviceApi.getAllDeviceViews()).data.data;
        deviceViews.forEach(deviceView=> deviceView.deviceTemplateConfiguration = JSON.parse(deviceView.deviceTemplate.configuration));
        setDeviceViews(deviceViews);
        return deviceViews;
    };

    let fetchLatestDeviceMetrics = async ()=> {
        deviceId2LatestDeviceMetrics = (await deviceMetricApi.batchGetLatestDeviceMetricsViews(deviceViews.map(deviceView=> deviceView.device.id))).data.data;
        setDeviceId2LatestDeviceMetrics(deviceId2LatestDeviceMetrics);
        return deviceId2LatestDeviceMetrics;
    };

    let refresh = async()=> {
        await fetchDeviceViews();
        await fetchLatestDeviceMetrics();
    };

    // effects
    useEffect(()=> {
        refresh();
    }, []);

    // render
    let getDeviceStatusText = (status: string)=> {
        switch (status) {
            case 'ONLINE':
                return '在线';
            case 'OFFLINE':
                return '离线';
            default:
                return '未知';
        }
    };

    let getDeviceStatusColor = (status: string)=> {
        switch (status) {
            case 'ONLINE':
                return 'rgba(28, 178, 115, 0.5)';
            case 'OFFLINE':
                return 'rgba(249, 125, 90, 0.5)';
            default:
                return 'rgba(249, 125, 90, 0.5)';
        }
    };

    // render
    return <ElectricWheelConciseOverviewWrapper>
        <ElectricWheelConciseInnerWrapper>
            <ScreenTitleBar>
                <Navigator selected="OVERVIEW"/>
            </ScreenTitleBar>

            <OverviewBigScreenContent>
                {
                    deviceViews.map(deviceView=> {
                        let realtimeDeviceMetrics = deviceId2LatestDeviceMetrics ? deviceId2LatestDeviceMetrics[deviceView.device.id] : null;
                        if (!realtimeDeviceMetrics) {
                            return <div></div>
                        }
                        let parkPressureProperty = deviceView.deviceTemplateConfiguration.properties.find(p=> p.key == 'park_pressure');
                        let parkTemperatureProperty = deviceView.deviceTemplateConfiguration.properties.find(p=> p.key == 'park_temperature');

                        let parkPressureError = false;
                        if (parkPressureProperty) {
                            if (parkPressureProperty.min && Number(realtimeDeviceMetrics[parkPressureProperty.key].value) < Number(parkPressureProperty.min)) {
                                parkPressureError = true;
                            } else if (parkPressureProperty.max && Number(realtimeDeviceMetrics[parkPressureProperty.key].value) > Number(parkPressureProperty.max)) {
                                parkPressureError = true;
                            }
                        }

                        let parkTemperatureError = false;
                        if (parkTemperatureProperty) {
                            if (parkTemperatureProperty.min && Number(realtimeDeviceMetrics[parkTemperatureProperty.key].value) < Number(parkTemperatureProperty.min)) {
                                parkTemperatureError = true;
                            } else if (parkTemperatureProperty.max && Number(realtimeDeviceMetrics[parkTemperatureProperty.key].value) > Number(parkTemperatureProperty.max)) {
                                parkTemperatureError = true;
                            }
                        }

                        return <DeviceWrapper key={deviceView.device.id}>
                            <DeviceHeader>
                                <Flex style={{flexDirection: 'row', alignItems: 'center', gap: '20px'}}>
                                    <DeviceIcon src={'/static/images/big-screen/electric-wheel-concise/electric-wheel-' + (deviceView.device.status == 'ONLINE' ? 'online' : 'offline') + '.png'}></DeviceIcon>
                                    <DeviceName>{deviceView.device.name}</DeviceName>
                                </Flex>
                                <DeviceStatus style={{backgroundColor: getDeviceStatusColor(deviceView.device.statu)}}>{getDeviceStatusText(deviceView.device.status)}</DeviceStatus>
                            </DeviceHeader>

                            <DeviceMetricsWrapper>
                                <DeviceMetricWrapper>
                                    <DeviceMetricStatusWrapper>
                                        <DeviceMetricStatus style={{backgroundColor: parkPressureError ? 'rgba(255, 0, 0, 0.5)' : 'rgba(28, 178, 115, 0.5)'}}>{parkPressureError ? '故障' : '正常'}</DeviceMetricStatus>
                                    </DeviceMetricStatusWrapper>
                                    <DeviceMetricValueWrapper>
                                        { parkPressureError && <DeviceMetricValue style={{color: '#FF0000'}}>故障</DeviceMetricValue> }
                                        { !parkPressureError && <DeviceMetricValue>{realtimeDeviceMetrics?.park_pressure?.value} <DeviceMetricUnit>{parkPressureProperty?.unit}</DeviceMetricUnit></DeviceMetricValue> }
                                        <DeviceMetricName>驻车压力</DeviceMetricName>
                                    </DeviceMetricValueWrapper>
                                </DeviceMetricWrapper>
                                <DeviceMetricWrapper>
                                    <DeviceMetricStatusWrapper>
                                        <DeviceMetricStatus style={{backgroundColor: parkTemperatureError ? 'rgba(255, 0, 0, 0.5)' : 'rgba(28, 178, 115, 0.5)'}}>{parkTemperatureError ? '故障' : '正常'}</DeviceMetricStatus>
                                    </DeviceMetricStatusWrapper>
                                    <DeviceMetricValueWrapper>
                                        { parkTemperatureError && <DeviceMetricValue style={{color: '#FF0000'}}>故障</DeviceMetricValue> }
                                        { !parkTemperatureError && <DeviceMetricValue>{realtimeDeviceMetrics?.park_temperature?.value} <DeviceMetricUnit>{parkTemperatureProperty?.unit}</DeviceMetricUnit></DeviceMetricValue> }
                                        <DeviceMetricName>驻车温度</DeviceMetricName>
                                    </DeviceMetricValueWrapper>
                                </DeviceMetricWrapper>
                            </DeviceMetricsWrapper>

                            <DeviceFooter>
                                <LastUpdatedTime>更新时间： {moment(Number(realtimeDeviceMetrics?.park_pressure?.timestamp)).format('YYYY-MM-DD HH:mm:ss')}</LastUpdatedTime>
                                <ViewDeviceDetails onClick={()=> navigate('/big-screen/electric-wheel-concise-details/' + deviceView.device.id)}>查看详情</ViewDeviceDetails>
                            </DeviceFooter>
                        </DeviceWrapper>
                    })
                }
            </OverviewBigScreenContent>
        </ElectricWheelConciseInnerWrapper>
    </ElectricWheelConciseOverviewWrapper>
};

export default ElectricWheelConciseOverview;


  